import { Box, makeStyles, SvgIcon as MuiSvgIcon } from "@material-ui/core";

type Props = {
  circleColor: string;
  icon: React.ReactNode;
};

export const CircleWithIcon = (props: Props) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <MuiSvgIcon
        viewBox="0 0 32 32"
        htmlColor={props.circleColor}
        className={classes.circle}
      >
        <circle cx="16" cy="16" r="16" />
      </MuiSvgIcon>
      <div className={classes.iconWrapper}>
        <div className={classes.svg}>{props.icon}</div>
      </div>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    display: "flex"
  },
  circle: {
    zIndex: 1,
    width: "calc(2rem + 1px)",
    height: "calc(2rem + 1px)"
  },
  iconWrapper: {
    position: "absolute",
    width: "1rem",
    height: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2
  },
  svg: {
    "& svg": {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0"
    }
  }
}));
